// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"632":"a0351d97","787":"cda612ba","883":"41103017"}[chunkId] + ".chunk.js";
};